const initVariantsTableSearch = () => {
    const searchInput = $('.variants-table-search')

    searchInput.on('keyup blur change search', (e) => {
        const searchValue = e.target.value
        const genericVariantRow = $('.generic-variant-row > td[data-key="PartCode"]')
        const activeItem = $('.v-tr.generic-variant-row.active')

        activeItem.trigger('click')

        genericVariantRow.each(function () {
            let elem = $(this)
            let elemText = elem.text().toUpperCase()
            if (elemText.includes(searchValue.toUpperCase())) {
                elem.parent().show(100)
            } else {
                elem.parent().hide(100)
            }
        })
    })
}

const initGroupedVariantsTableSearch = (variants, groupByKey) => {
    const searchInput = $('.variants-table-search')

    searchInput.on('keyup blur change search', (e) => {
        const searchValue = e.target.value
        const matchingVariants = variants.filter((variant) => variant.PartCode.toLowerCase().includes(searchValue.toLowerCase()))

        if (!matchingVariants.length) {
            $('.generic-variant-row').hide(100)
            return
        }
        const uniqueValues = [...new Set(matchingVariants.map((item) => item[groupByKey]))]
        const genericVariantRow = $(`.generic-variant-row > td[data-key="${groupByKey}"]`)

        genericVariantRow.each(function () {
            let elem = $(this)
            let elemText = elem.text().toUpperCase()
            const matches = uniqueValues.some((value) => elemText === value)

            if (matches) {
                elem.parent().show(100)
            } else {
                elem.parent().hide(100)
            }
        })
    })
}

const initVariantsTableToggle = () => {
    const toggleButton = $('.variants-table-toggle')
    const iconArrow = toggleButton.find('.icon-arrow')
    const targetElement = $('.filter')

    toggleButton.on('click', () => {
        targetElement.slideToggle('fast')
        iconArrow.toggleClass('up', 'down')
    })
}

export { initVariantsTableSearch, initGroupedVariantsTableSearch, initVariantsTableToggle }
